import { carouselItems } from '@/mocks/homeMangaData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            编辑团队精心策划的漫画专题推荐，每期聚焦不同主题
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={item.id}
              className={`group flex flex-col md:flex-row gap-5 md:gap-8 ${item.color} rounded-2xl p-5 md:p-7 border border-background-200/60 hover:border-primary-200 transition-all duration-300`}
            >
              <div className="flex-shrink-0 w-full md:w-[300px] lg:w-[360px] h-48 md:h-[220px] rounded-xl overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.subtitle}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="600"
                  height="400"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    (t.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-block px-2.5 py-0.5 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">专题 #{idx + 1}</span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm md:text-base text-foreground-600 font-medium mb-3">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}